import React, { useEffect, useRef, useState } from 'react';
import Offcanvas from 'react-bootstrap/Offcanvas';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Divider from '@mui/material/Divider';
import LightbulbIcon from '@mui/icons-material/Lightbulb';
import EnergySavingsLeafIcon from '@mui/icons-material/EnergySavingsLeaf';
import AccountTreeIcon from '@mui/icons-material/AccountTree';
import WaterDamageIcon from '@mui/icons-material/WaterDamage';
import InsightsIcon from '@mui/icons-material/Insights';
import HMobiledataIcon from '@mui/icons-material/HMobiledata';
import AssignmentIcon from '@mui/icons-material/Assignment';
import RequestQuoteIcon from '@mui/icons-material/RequestQuote';
import PersonIcon from '@mui/icons-material/Person';
import LogoutIcon from '@mui/icons-material/Logout';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import EngineeringIcon from '@mui/icons-material/Engineering';
import fLogo from '../../media/cropped-env_brandguidelines-2_031.png';
import { useNavigate } from 'react-router-dom';
import useLogout from '../../hooks/useLogout';
import useAuth from '../../hooks/useAuth';
import useAxiosProtect from '../../hooks/useAxiosProtect';
import jwtDecode from 'jwt-decode';
import ThumbLogo from '../../media/BeaverIcon.png';
import CloudIcon from '@mui/icons-material/Cloud';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import SpeedIcon from '@mui/icons-material/Speed';
import './CanvasDrawer.css'
import AdminCanvasDrawerOptions from './AdminCanvasDrawerOptions';
import CreateNewFolderIcon from '@mui/icons-material/CreateNewFolder';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import { isMobile } from 'react-device-detect';

const CanvasDrawer = props => {
    const navigate = useNavigate();
    const logout = useLogout();
    const axiosProtect = useAxiosProtect();

    const signOut = async () => {
        await logout();
        navigate('/');
    }

    var init = useRef(true);
    var disableOnClick = useRef(false); // set true to prevent user from running same onClick before completion
    const {auth, persist} = useAuth();
    const siteID = window.location.href.split('/')[window.location.href.split('/').length - 1];
    const [isAdmin, setIsAdmin] = useState(false);
    const [isCarbonOneUser, setIsCarbonOneUser] = useState(false);
    const [isHMartUser, setIsHMartUser] = useState(false);
    const [isASBRUser, setIsASBRUser] = useState(false);
    const [uid, setUid] = useState('');
    const [isTestClient, setIsTestClient] = useState(false);

    useEffect(() => {
        if(init.current){
            init.current = false;

            if(auth?.accessToken){
                let tokenObj = jwtDecode(auth.accessToken);
                setIsAdmin(tokenObj.role === process.env.REACT_APP_ES_ADMIN);
                setIsCarbonOneUser(tokenObj.role === process.env.REACT_APP_CARBON_ONE_USER);
                setIsHMartUser(tokenObj.role === process.env.REACT_APP_HMART_USER);
                setIsASBRUser(tokenObj.role === process.env.REACT_APP_BLUE_ROOF_CLIENT);
                setIsTestClient(tokenObj.email === "placeholder")
                setUid(tokenObj.id);
            }
        }
    }, []);

    const navigateAndClose = path => {
        navigate(path);
        props.handleClose();
    }

    return(
        <>
            <Offcanvas.Header closeButton>
                <Offcanvas.Title><img id='drawer-nav-img' src={ThumbLogo} style={{height:'5rem', widht:'auto', cursor:'pointer', borderRadius:'50%', padding:'0.5rem'}} onMouseEnter={() => {
                    document.getElementById('drawer-nav-img').style.backgroundColor = 'rgba(0,0,0,0.1)';
                }} onMouseLeave={() => {
                    document.getElementById('drawer-nav-img').style.backgroundColor = 'rgba(0,0,0,0)';
                }} onClick={() => {
                    navigateAndClose('/dashboard');
                }}/></Offcanvas.Title>
            </Offcanvas.Header>

            <Divider style={{backgroundColor:'rgb(226,227,232)'}}/>

            <Offcanvas.Body>
                {
                    isMobile ?
                    <>
                    <div style={{position:'relative', height:'100%', width:'100%'}}>
                        <ListItem disablePadding onClick={() => {
                            if(disableOnClick.current) return;

                            disableOnClick.current = true;
                            
                            axiosProtect.get(`/auth/query/list-client-site-access?uid=${uid}`).then(response => {
                                let siteID = response.data.sites[0].id;
                                navigateAndClose(`/energy-metrics/${siteID}`);

                                disableOnClick.current = false;
                            }).catch(err => {
                                disableOnClick.current = false;
                            });
                        }}>
                            <ListItemButton>
                                <ListItemIcon>
                                    <EnergySavingsLeafIcon className="text-brand"/>
                                </ListItemIcon>
                                <ListItemText primary="Utility data" className="text-muted-dark"/>
                            </ListItemButton>
                        </ListItem>

                        <List className='scrollable-list'>
                            <ListItem disablePadding onClick={() => {
                                signOut();
                            }}>
                                <ListItemButton>
                                    <ListItemIcon>
                                        <LogoutIcon className="text-brand"/>
                                    </ListItemIcon>
                                    <ListItemText primary="Log out" className="text-muted-dark"/>
                                </ListItemButton>
                            </ListItem>
                        </List>
                    </div>
                    </>
                    :
                    <>
                    <div style={{position:'relative', height:'100%', width:'100%'}}>
                        <List className='scrollable-list'>
                            {isAdmin ? <>
                                <AdminCanvasDrawerOptions disableOnClick={disableOnClick} handleClose={props.handleClose}/>

                                <Divider sx={{ borderColor: 'black', my: 1 }} textAlign="left">
                                    <span style={{ color: 'black', fontWeight: 'bold' }}>Management</span>
                                </Divider>
                                <ListItem disablePadding onClick={() => navigateAndClose('/pricing')}>
                                    <ListItemButton>
                                        <ListItemIcon>
                                            <RequestQuoteIcon className="text-brand"/>
                                        </ListItemIcon>
                                        <ListItemText primary="Pricing calculator" className="text-muted-dark"/>
                                    </ListItemButton>
                                </ListItem>
                                <ListItem disablePadding onClick={() => navigateAndClose('/ghg-factors')}>
                                    <ListItemButton>
                                        <ListItemIcon>
                                            <LightbulbIcon className="text-brand"/>
                                        </ListItemIcon>
                                        <ListItemText primary="GHG Factors" className="text-muted-dark"/>
                                    </ListItemButton>
                                </ListItem>
                                <ListItem disablePadding onClick={() => navigateAndClose('/projects')}>
                                    <ListItemButton>
                                        <ListItemIcon>
                                            <AccountTreeIcon className="text-brand"/>
                                        </ListItemIcon>
                                        <ListItemText primary="Project Management" className="text-muted-dark"/>
                                    </ListItemButton>
                                </ListItem>
                                <ListItem disablePadding onClick={() => navigateAndClose('/blueroof')}>
                                    <ListItemButton>
                                        <ListItemIcon>
                                            <WaterDamageIcon className="text-brand"/>
                                        </ListItemIcon>
                                        <ListItemText primary="Blue Roof" className="text-muted-dark"/>
                                    </ListItemButton>
                                </ListItem>
                                <ListItem disablePadding onClick={() => navigateAndClose('/customer-management')}>
                                    <ListItemButton>
                                        <ListItemIcon>
                                            <ManageAccountsIcon className="text-brand"/>
                                        </ListItemIcon>
                                        <ListItemText primary="Customer Management" className="text-muted-dark"/>
                                    </ListItemButton>
                                </ListItem>
                                <ListItem disablePadding onClick={() => navigateAndClose('/hmart')}>
                                    <ListItemButton>
                                        <ListItemIcon>
                                            <HMobiledataIcon className="text-brand"/>
                                        </ListItemIcon>
                                        <ListItemText primary="H-Mart System" className="text-muted-dark"/>
                                    </ListItemButton>
                                </ListItem>
                            </> : (isCarbonOneUser || isHMartUser || isASBRUser) ?
                            <>

                            </> :
                            <>
                                <ListItem disablePadding onClick={() => {
                                    navigateAndClose('/opportunities');
                                }}>
                                    <ListItemButton>
                                    <ListItemIcon>
                                        <LightbulbIcon className="text-brand"/>
                                    </ListItemIcon>
                                    <ListItemText primary='Opportunities' className="text-muted-dark"/>
                                    </ListItemButton>
                                </ListItem>

                                <ListItem disablePadding onClick={() => {
                                    if(disableOnClick.current) return;

                                    disableOnClick.current = true;
                                    
                                    axiosProtect.get(`/auth/query/list-client-site-access?uid=${uid}`).then(response => {
                                        let siteID = response.data.sites[0].id;
                                        navigateAndClose(`/energy-metrics/${siteID}`);

                                        disableOnClick.current = false;
                                    }).catch(err => {
                                        disableOnClick.current = false;
                                    });
                                }}>
                                    <ListItemButton>
                                        <ListItemIcon>
                                            <EnergySavingsLeafIcon className="text-brand"/>
                                        </ListItemIcon>
                                        <ListItemText primary="Raw data" className="text-muted-dark"/>
                                    </ListItemButton>
                                </ListItem>

                                {/* <ListItem disablePadding>
                                    <ListItemButton disabled={!isTestClient}>
                                    <ListItemIcon>
                                        <PrecisionManufacturingIcon className="text-brand"/>
                                    </ListItemIcon>
                                    <ListItemText primary={`Production metrics${isTestClient ? '' : ' (Coming soon)'}`} className="text-muted-dark"/>
                                    </ListItemButton>
                                </ListItem> */}

                                <ListItem disablePadding onClick={() => {navigateAndClose('/emissions-savings')}}>
                                <ListItemButton style={{width:'100%'}}>
                                    <ListItemIcon>
                                        <SpeedIcon className="text-brand"/>
                                    </ListItemIcon>
                                    <ListItemText primary={`Savings`} className="text-muted-dark"/>
                                </ListItemButton>
                            </ListItem>
                            <ListItem disablePadding onClick={() => {navigateAndClose('/emissions-trends')}}>
                                <ListItemButton style={{width:'100%'}}>
                                    <ListItemIcon>
                                        <InsightsIcon className="text-brand"/>
                                    </ListItemIcon>
                                    <ListItemText primary={`Glidepath`} className="text-muted-dark"/>
                                </ListItemButton>
                            </ListItem>

                                

                                {/* <ListItem disablePadding onClick={() => {navigateAndClose('/infographics/guest')}}>
                                    <ListItemButton>
                                    <ListItemIcon>
                                        <InsightsIcon className="text-brand"/>
                                    </ListItemIcon>
                                <ListItemText primary={`Infographics${isTestClient ? '' : ' (Coming soon)'}`} className="text-muted-dark"/>
                                    </ListItemButton>
                                </ListItem> */}

                                <ListItem disablePadding onClick={() => {navigateAndClose('/activity-log')}}>
                                    {/* <ListItem disablePadding onClick={() => {if(!isTestClient) return; navigateAndClose('/emissions')}}> */}
                                    <ListItemButton>
                                    {/* <ListItemButton disabled={!isTestClient}> */}
                                    <ListItemIcon>
                                        <AssignmentIcon className="text-brand"/>
                                    </ListItemIcon>
                                    <ListItemText primary={`Activity log`} className="text-muted-dark"/>
                                    </ListItemButton>
                                </ListItem>

                                <ListItem disablePadding onClick={() => {navigateAndClose('/utility-trend')}}>
                                <ListItemButton style={{width:'100%'}}>
                                    <ListItemIcon>
                                        <CreateNewFolderIcon className="text-brand"/>
                                    </ListItemIcon>
                                    <ListItemText primary={`Utility Bills`} className="text-muted-dark"/>
                                </ListItemButton>
                            </ListItem>
                            <ListItem disablePadding onClick={() => {navigateAndClose('/overview')}}>
                                <ListItemButton style={{width:'100%'}}>
                                    <ListItemIcon>
                                        <CalendarTodayIcon className="text-brand"/>
                                    </ListItemIcon>
                                    <ListItemText primary={`Monthly Data Table`} className="text-muted-dark"/>
                                </ListItemButton>
                            </ListItem>
                            </>}

                            <Divider style={{backgroundColor:'rgb(226,227,232)'}}/>

                            <ListItem disablePadding onClick={() => navigateAndClose('/profile')}>
                                <ListItemButton>
                                <ListItemIcon>
                                    <PersonIcon className="text-brand"/>
                                </ListItemIcon>
                                <ListItemText primary="Profile" className="text-muted-dark"/>
                                </ListItemButton>
                            </ListItem>

                            {/* <ListItem disablePadding>
                                <ListItemButton disabled={!isTestClient}>
                                <ListItemIcon>
                                    <TuneIcon className="text-brand"/>
                                </ListItemIcon>
                                <ListItemText primary="Settings" className="text-muted-dark"/>
                                </ListItemButton>
                            </ListItem> */}

                            <ListItem disablePadding onClick={() => {
                                signOut();
                            }}>
                                <ListItemButton>
                                    <ListItemIcon>
                                        <LogoutIcon className="text-brand"/>
                                    </ListItemIcon>
                                    <ListItemText primary="Log out" className="text-muted-dark"/>
                                </ListItemButton>
                            </ListItem>
                        </List>

                        <a href="https://enviro-stewards.com/" target="_blank">
                            <img src={fLogo} alt="Logo"
                                style={{position:'absolute',top:'0',left:'0',bottom:'0',right:'0',width:'auto',height:'auto',maxWidth:'100%',maxHeight:'100%',margin:'auto auto 0'
                                }}
                            />
                            </a>
                    </div>
                    </>
                }
            </Offcanvas.Body>
            </>
    );
}

export default CanvasDrawer;